import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    textSearch:"",
    searchBarPosition:"",
    moduleClicked:0,
    isCollectionCL:false
}

export const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setTextSearch: (state, action) => {
      state.textSearch = action.payload;
    },
    setSearchBarPosition: (state, action) => {
      state.searchBarPosition = action.payload;
    },
    setModuleClicked: (state, action) => {
      state.moduleClicked = action.payload;
    },
    setIsCollectionCL: (state, action) => {
      state.isCollectionCL = action.payload;
    }
  },
})

// Action creators are generated for each case reducer function
export const { setTextSearch, setSearchBarPosition, setModuleClicked, setIsCollectionCL } = searchSlice.actions

export default searchSlice.reducer